import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall,
  getBranches,
  getIncomeCategories
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
class IncomeDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      income: [],
      categories: [],
      branches: [],
      isLoad: true,
      loading: false,
      formData: {
        id: '',
        category_id: '',
        branch_id: '',
        description: '',
        type: 'Gelir',
        amount: '',
        income_date: '',
      }
    }
  }
  async componentDidMount() {
    try {
      await this.getIncomeInfo();
      this.setState({
        branches: await getBranches(),
        categories: await getIncomeCategories() || []
      });
    } catch (e) {
      throw e;
    }
  }
  getIncomeInfo = async () => {
    const id = this.props.match.params.id;
    try {
      const response = await apiCall('business/income/info/' + id, 'get', null);
      const updatedData = { ...this.state.formData };
      Object.keys(updatedData).forEach(key => {
        updatedData[key] = response[key] === undefined || response[key] === null ? "" : response[key];
      });

      this.setState({
        formData: updatedData,
        isLoad: false
      });
    } catch (e) {
      console.error(e);
    }
  }
  handleChange = (e) => {
    const { id, value } = e.target;

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: value
      }
    }));
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { formData } = this.state;
    const IncomeFormData = new FormData();
    Object.keys(formData).forEach(key => {
      IncomeFormData.append(key, formData[key]);
    });

    try {
      const response = await apiCall('business/income/update/' + formData.id, 'post', IncomeFormData);
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message)
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  render() {
    const { formData, branches, categories, loading } = this.state;
    const { userPermissions } = this.props;
    const userHasUpdateIncomePermission = userPermissions.includes('update income');
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Gelir detayları"
              Breadcrumb={[
                { name: "Gelir Gider Takibi", navigate: "" },
                { name: "Gelirler", navigate: "incomes" },
                { name: "Detay", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">

                  <form onSubmit={this.handleSubmit}>
                    <div className="body">
                      <h6>Gelir Detayı</h6>
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="category_id"
                              className="font-weight-bold text-cyan">
                              Kategori
                            </label>
                            <select id='category_id'
                              className="form-control"
                              value={formData.category_id}
                              onChange={this.handleChange}>
                              <option value="">Müşteri Seçiniz</option>
                              {categories && (categories.map(category => (
                                <option key={category.id}
                                  value={category.id}>{category.name}</option>
                              )))}

                            </select>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="branch_id"
                              className="font-weight-bold text-cyan">
                              Şube
                            </label>
                            <select id='branch_id'
                              className="form-control"
                              value={formData.branch_id}
                              onChange={this.handleChange}>
                              <option value="">Şube Seçiniz</option>
                              {branches && (branches.map(branch => (
                                <option key={branch.id}
                                  value={branch.id}>{branch.name}</option>
                              )))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="category_id"
                              className="font-weight-bold text-cyan">
                              Gelir Tarihi
                            </label>
                            <input
                              id="income_date"
                              type="date"
                              className="form-control"
                              value={formData.income_date}
                              onChange={this.handleChange} />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="customer_id"
                              className="font-weight-bold text-cyan">
                              Detay
                            </label>
                            <textarea
                              id="description"
                              className="form-control"
                              placeholder="Açıklama"
                              value={formData.description}
                              onChange={this.handleChange}>
                            </textarea>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="kdv"
                              className="font-weight-bold text-cyan">
                              Tutar
                            </label>
                            <input
                              id="amount"
                              type="number"
                              className="form-control"
                              placeholder="Tutar giriniz"
                              value={formData.amount}
                              onChange={this.handleChange} />
                          </div>
                        </div>
                      </div>

                    </div>
                    <div className="body">
                      <div className="row clearfix justify-content-center">
                        <div className="col-lg-6 col-md-12">
                          {loading ? (
                            <button className="btn btn-outline-primary btn-block"
                              disabled={true}
                              style={{ textAlign: "-webkit-center" }}>
                              Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                height={'24px'}
                                color="#268bd2"></ReactLoading>
                            </button>
                          ) :
                            <button disabled={!userHasUpdateIncomePermission}
                              className="btn btn-outline-primary btn-block"
                              type="submit">
                              Güncelle
                            </button>}

                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(IncomeDetail)));
